<template>
  <div
    class="pa-3"
  >
    <v-row class="mb-2" no-gutters>
      <v-chip
        class="mr-1"
        label
        v-for="(value, key) in filter"
        v-bind:key="key"
        outlined
        close
        close-icon="mdi-close"
        @click:close="removeFilter(key)"
      >
        <strong>{{ $helpers.getLabel(key) }}:</strong>&nbsp; 
        <span v-if="key == 'org_guid'">{{ $organizations.getOrg(value).displayName() }}</span>
        <span v-else-if="key == 'profile_guid'">{{ $entitlementProfiles.getEntitlementProfile(value).displayName() }}</span>
        <span v-else-if="key == 'profile_platform'">{{ $helpers.getLabel(value) }}</span>
        <span v-else>{{ value }}</span>
      </v-chip>
    </v-row>
    
    <v-row align="center" no-gutters>
      <v-col cols="5">
        <v-select
          v-model="filterType"
          :items="availableFilterTypes"
          label="Filter Type"
          @change="filterValue = ''"
          hide-details
          outlined
        >
        </v-select>
      </v-col>
      <v-col cols="5">
        <org-selector 
          v-if="filterType == 'org_guid'"
          v-model="filterValue"
          class="ma-1"
        />
        
        <profile-selector
          v-else-if="filterType == 'profile_guid'"
          v-model="filterValue"
          class="ma-1"
        />
        
        <v-select
          v-else-if="filterType == 'profile_platform'"
          v-model="filterValue"
          :items="productNames"
          label="Platform"
          class="ma-1"
          hide-details
          outlined
        >
        </v-select>
        
        <v-menu
          v-else-if="dateFields.includes(filterType)"
          v-model="datePicker"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              class="ma-1"
              v-model="filterValue"
              label="Date"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="filterValue"
            @input="datePicker = false"
          ></v-date-picker>
        </v-menu>
        
        <v-text-field
          v-else
          class="ma-1"
          v-model="filterValue"
          label="Filter Value"
          outlined
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="2" align="center">
        <v-btn
          small
          text
          @click="addFilter"
        >
          <v-icon>add</v-icon> Add Filter
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import OrgSelector from '../../organization/OrgSelector.vue' 
  import ProfileSelector from '../../entitlements/components/ProfileSelector.vue'
  
  export default {
    name: 'SearchFilter',
    
    components: {
      OrgSelector,
      ProfileSelector
    },
    
    data() {
      return {
        filter: {},
        
        datePicker: false,
        
        filterTypes: [
          'org_guid', 
          'license_name', 
          'sales_order', 
          'profile_guid', 
          'profile_platform', 
          'serial_number', 
          'created_start',
          'created_end',
          'expires_start',
          'expires_end'
        ],
        
        dateFields: [
          'created_start',
          'created_end',
          'expires_start',
          'expires_end'
        ],
        
        filterType: '',
        filterValue: ''
      }
    },
    
    props: ['value', 'filters'],
    
    watch: {
      value(value) {
        this.filter = value
      },
      
      filter() {
        this.$emit('input', this.filter)
      },
    },
    
    mounted() {
      this.filter = this.value
    },
    
    computed: {
      availableFilterTypes() {
        var usedFilters = Object.keys(this.filter)
        
        var availableFilters = (this.filters) ?  this.filters : this.filterTypes
        
        return availableFilters.filter(item => {
          return usedFilters.indexOf(item) === -1
        }).map(item => {
          return {'value': item, 'text': this.$helpers.getLabel(item)}
        })
      },
      productNames() {
        var productNames = this.$capabilities.allProducts()
        return productNames.map(item => {
          return {'value': item, 'text': this.$helpers.getLabel(item)}
        })
      }
    },
    
    methods: {
      valueChanged() {
        this.$emit('change', this.filter)
      },
      
      addFilter() {
        console.log('SearchFilter addFilter', this.filterType, this.filterValue)
        if (this.filterType && this.filterValue) {
          this.$set(this.filter, this.filterType, this.filterValue)
          this.filterValue = ''
        }
      },
      
      removeFilter(key) {
        console.log('SearchFilter removeFilter', key)
        this.$delete(this.filter, key)
      }
    }
  }
</script>